import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore, runInAction } from '@/common/dependencies';
import navbarStore from '@/store/navbar';
import Conf from '@/common/conf';
import Loader from '@/common/helper/loader';
import "./index.scss";
import { useEffect } from 'react';
import { request } from '@/common';

const KnowledgeWelcome = observer((props) => {
  const {
    onSend,
    knowledgeId,
    knowledgeksId,
  } = props;

  const roleInfo = navbarStore.chatModels[Conf.roleIds.knowledge];
  const store = useLocalObservable(() => ({
    sayList : [],

    updateSayLit (folder_id, ks_id = '') {
      request.get("/knowledge/sug", {
        params : {
          folder_id,
          ks_id,
        },
      })
      .then(res => {
        runInAction(() => {
          this.sayList = res.data || [];
        });
      })
    },
  }));

  useEffect(() => {
    if(!knowledgeId){
      return;
    }

    store.updateSayLit(knowledgeId, knowledgeksId);
  }, [knowledgeId, knowledgeksId]);

  // if(!roleInfo){
  //   return (
  //     <div className="h-full flex flex-col items-center justify-center">
  //       <img src="https://p4.ssl.qhimg.com/t11098f6bcdced3731ed065f54a.png" className="size-114px -mt-80px" />
  //       <div className="text-14px leading-20px mt-16px text-black">任何有关这个知识库的问题，都可以向纳米AI提问</div>
  //     </div>
  //   )
  // }

  // 没有提取到推荐问题之前，不显示
  // if(!store.sayList.length){
  //   return null;
  // }

  return (
    <div className='h-full flex flex-col items-center justify-center pb-150px'>
      <div className="size-96px">
        <img className='size-full rounded-full' src={Loader.getModelIcon(roleInfo)} />
      </div>
      <div className="mt-16px text-24px leading-34px font-bold">
        {roleInfo.title}
      </div>
      <div className="mt-6px text-14px leading-20px text-black text-opacity-50">
        创建人：纳米AI
      </div>
      <div className="mt-16px text-16px leading-30px">
        {roleInfo.description}
      </div>

      <div className="knowledge-saylist-container flex flex-wrap">
        {
          store.sayList.map(item => {
            return (
              <div 
                key={item}
                className="knowledge-saylist-item overflow-hidden w-148px h-112px rounded-12px border-1px border-black border-opacity-10 p-16px cursor-pointer hover:bg-[rgba(0,0,0,.03)] mr-10px mb-10px text-black text-opacity-70 text-14px leading-20px overflow-hidden"
                onClick={
                  () => {
                    onSend({ value: item })
                  }
                }>
                <div className="line-clamp-4" title={item}>
                  {item}
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
});
export default KnowledgeWelcome;